/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendSummaryBaseFilters {
    getFixupPrototypeFunction() { return InfraResourceTrendSummaryBaseFilters.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendSummaryBaseFilters>): InfraResourceTrendSummaryBaseFilters {
        let obj = Object.assign(new InfraResourceTrendSummaryBaseFilters(), model);
        InfraResourceTrendSummaryBaseFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendSummaryBaseFilters>): InfraResourceTrendSummaryBaseFilters {
        if (!model) return null;
        return InfraResourceTrendSummaryBaseFilters.newInstance(<InfraResourceTrendSummaryBaseFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendSummaryBaseFilters) {
        if (!obj) return;

        models.InfraResourceTrendSummaryBaseFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendSummaryBaseFilters): boolean {
        Object.setPrototypeOf(obj, InfraResourceTrendSummaryBaseFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID to filter the resources. This can be fetched from the List Tenants API call.
     */
    tenant_id: string;

    /**
     * Query based on Cloud Providers, Cloud Account Ids, Statuses, Severities, ResourceCategories, ResourceTypes, Resources, Resource ID(s)
     */
    query: models.QueryOperator;

}
